import '../../../coral-library/css/_layout.scss'
import './CoralPdpCompatibleWith.scss'

import { Asset } from '@websrc/App/Components/Asset/Asset'
import { CTA } from '@websrc/App/Components/CTA'
import { mapCoralWebPdpCompatibleWith } from '@websrc/DataMappers/mapSpot'
import React, { FC, useRef } from 'react'

type CoralPdpCompatibleWithProps = ReturnType<typeof mapCoralWebPdpCompatibleWith>

export const CoralPdpCompatibleWith: FC<CoralPdpCompatibleWithProps> = ({ header, cards }) => {
  const ctaRefs = useRef<(HTMLAnchorElement | null)[]>([])
  return (
    <div className={'container-coral-spot'}>
      <div className={'comp-with'}>
        <div className={'comp-with__header'}>{header}</div>
        <div className={'comp-with__cards-wrapper'}>
          {cards.map((card, index) => (
            <div
              className={'comp-with__card'}
              key={index}
              onClick={(e) => {
                ctaRefs.current[index]?.click()
                e.stopPropagation()
              }}
            >
              <div className={`comp-with__card__asset  m--${card.image_background_color}`}>
                <Asset
                  lazyLoading={true}
                  objectFit={'cover'}
                  srcSetWidths={[400, 600, 800, 1000]}
                  thumbnail={card.asset?.thumbnail}
                  video={card.asset?.video}
                />
              </div>
              <div className={'comp-with__card__content'}>
                {card.enable_lego_education_r && (
                  <div className={'comp-with__card__le-prefix'}>{card.brand}</div>
                )}
                <div className={'comp-with__card__heading'}>{card.description}</div>
                <div className={'cta-override-wrapper'}>
                  <CTA
                    className={'comp-with__card__button'}
                    colorTheme={'black'}
                    cta={card.button}
                    ref={(e) => (ctaRefs.current[index] = e)}
                    type={'primary'}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
